
import React from 'react';
import { Button } from '@/components/ui/button';
import { Trash } from 'lucide-react';
import { CardFooter } from '@/components/ui/card';

interface PollActionsProps {
  isCreator: boolean;
  isClosed: boolean;
  isDeleting: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const PollActions: React.FC<PollActionsProps> = ({
  isCreator,
  isClosed,
  isDeleting,
  onClose,
  onDelete
}) => {
  if (!isCreator) return null;

  return (
    <CardFooter className="justify-end pt-0 gap-2">
      {!isClosed && (
        <Button 
          variant="outline" 
          size="sm"
          onClick={onClose}
        >
          Close Poll
        </Button>
      )}
      
      <Button 
        variant="destructive" 
        size="sm"
        onClick={onDelete}
        disabled={isDeleting}
        className="flex items-center gap-1"
      >
        <Trash className="h-4 w-4" />
        Delete
      </Button>
    </CardFooter>
  );
};

export default PollActions;
